/**
 * Mounts the svelte app
 */
import App from "./App.svelte"
import "./common.min.css"
import "./normalize.css"

const app = new App({
  target: document.getElementById("app"),
  props: {}
})
